import { type FC } from 'react'
import { Controller, type UseFormReturn } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { Checkbox, Heading } from 'base-ui'

import { type MarketplacePartnerRegisterPageFormV3Values } from '../../../hooks/marketplacePartnerRegisterPageFormV3RHFModel'

type MarketplacePartnerRegisterPageFormV3MarketingProps = {
  form: UseFormReturn<MarketplacePartnerRegisterPageFormV3Values>
}

export const MarketplacePartnerRegisterPageFormV3Marketing: FC<
  MarketplacePartnerRegisterPageFormV3MarketingProps
> = ({ form }) => {
  const retailMediaUrl = 'https://retailmedia.redcare-pharmacy.com/de/home'
  const retailMediaLink = (
    <a href={retailMediaUrl} rel="noreferrer" target="_blank">
      {retailMediaUrl}
    </a>
  )

  return (
    <div className="flex flex-col gap-10">
      <Heading level={2} size="l">
        <FormattedMessage id="marketplacePartnerRegisterPage.marketing.title" />
      </Heading>
      <Controller
        control={form.control}
        name="interestedInRetailMedia"
        render={({ field }) => (
          <label className="flex items-center gap-2">
            <Checkbox
              checked={field.value}
              className="shrink-0"
              data-qa-id="sellerForm-checkbox-interestedInRetailMedia"
              onChange={(event): void => {
                field.onChange(event.target.checked)
              }}
              size="medium"
            />
            <div>
              <FormattedMessage
                id="marketplacePartnerRegisterPage.marketing.retailMediaMarketing.label"
                values={{
                  retailMediaLink,
                }}
              />
            </div>
          </label>
        )}
      />
    </div>
  )
}
